module.exports = __webpack_public_path__ + "img/tongna.94985060.png";